import moment from 'moment';
import {SICKNESS} from 'common/domain/constants';
import {Request} from 'common/domain/models/request';

export default class PeriodActionsHelper {
  constructor(period, isInception) {
    this.period = period;
    this.isInception = isInception;
  }

  available() {
    if (!this.period) {
      return false;
    }

    return this.canInsertAbsence() || this.periodCanBeEdited() || this.periodCanBeRemoved();
  }

  canInsertAbsence() {
    return  Request.isApproved(this.period) && !(this.period.code === SICKNESS.CODES[1] || this.period.code === SICKNESS.CODES[2]);
  }

  periodCanBeEdited() {
    const isNotSickness = SICKNESS.CODES.indexOf(this.period.code) === -1;
    const finishedPeriod = moment().isAfter(this.period.endDate);

    if (isNotSickness && finishedPeriod) {

      return false;
    }

    if (this.isVacationOnInception()) {
      return false;
    }

    if(this.isInception){
      return Request.isRequested(this.period) && (this.period.code === SICKNESS.CODES[1] || this.period.code === SICKNESS.CODES[2]);
    }

    return Request.isRequested(this.period);

  }

  periodCanBeRemoved() {
    const approvedOrRequested = Request.isRequested(this.period) || Request.isApproved(this.period);
    const isSick = Request.isSick(this.period);
    return (approvedOrRequested && !isSick) && !this.isInception;
  }

  isFinishedSickPeriod() {
    return Request.isFinishedSick(this.period) && Request.isApproved(this.period);
  }

  isVacationOnInception() {
    return Request.isVacation(this.period) && this.isInception;
  }
}



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/helpers/periodActions.helpers.js